import { formatNumber, formatPercent } from "../utils";
import { findChannel } from "../../../channelLinks";

const EMPTY = <span className="text-gray-300">—</span>;

/**
 * 캠페인(UTM) 조합 표: 소스(?src= 또는 utm_source) · 매체(utm_medium) · 캠페인(utm_campaign).
 * rows: [{ source, medium, campaign, visits?, clicks, clickRate? }] — visits 가 있으면 방문·클릭률 열도 보인다
 */
export function FgUtmTable({ rows, emptyText = '이 기간에 UTM 이 붙은 기록이 없습니다.' }) {
    if (!rows.length) {
        return <p className="py-4 text-xs text-gray-400">{emptyText}</p>;
    }

    const withVisits = rows[0].visits !== undefined;

    return (
        <div className="-mx-1 overflow-x-auto">
            <table className="w-full min-w-[420px] text-left text-[13px]">
                <thead className="text-[11px] text-gray-400">
                    <tr>
                        <th className="px-1 py-1.5 font-normal">소스</th>
                        <th className="px-1 py-1.5 font-normal">매체</th>
                        <th className="px-1 py-1.5 font-normal">캠페인</th>
                        {withVisits && <th className="px-1 py-1.5 text-right font-normal">방문</th>}
                        <th className="px-1 py-1.5 text-right font-normal">링크 클릭</th>
                        {withVisits && <th className="px-1 py-1.5 text-right font-normal" title="링크 클릭 ÷ 방문">클릭률</th>}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(r => (
                        <tr key={`${r.source}|${r.medium}|${r.campaign}`} className="border-t border-gray-100 text-gray-800">
                            <td className="max-w-[140px] truncate px-1 py-2 font-semibold" title={r.source || ''}>
                                {r.source || EMPTY}
                                {findChannel(r.source, r.medium) && <span className="block text-[11px] font-normal text-gray-400">{findChannel(r.source, r.medium).label} 채널 링크</span>}
                            </td>
                            <td className="max-w-[120px] truncate px-1 py-2" title={r.medium || ''}>{r.medium || EMPTY}</td>
                            <td className="max-w-[160px] truncate px-1 py-2" title={r.campaign || ''}>{r.campaign || EMPTY}</td>
                            {withVisits && <td className="px-1 py-2 text-right">{formatNumber(r.visits)}</td>}
                            <td className="px-1 py-2 text-right font-semibold">{formatNumber(r.clicks)}</td>
                            {withVisits && <td className="px-1 py-2 text-right text-gray-500">{formatPercent(r.clickRate)}</td>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
